import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { UserDetailsModel } from "@tCooneyBrothers/ApiModels";

const userDetailsUrl = "api/v2/userprofilecustomdata";

export function getUserDetails() {
    return get<UserDetailsModel[]>(`${userDetailsUrl}`, {});
}

export interface GetUserDetailsApiParameter extends ApiParameter {
    id?: string;
    description: string;
}
